module.exports = __webpack_public_path__ + "static/media/login-bg2.5a6f4eec.png";